import { render, staticRenderFns } from "./MarketTours.vue?vue&type=template&id=07f06d4c&"
import script from "./MarketTours.vue?vue&type=script&lang=js&"
export * from "./MarketTours.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports